<template>
  <b-modal 
    id="error_modal"
    v-if="value"
    title="Error"
    v-bind:visible="value !== null"
    hide-header-close
    centered
    v-bind:no-close-on-backdrop="okHidden"
  >
    <p class="sedna_error_modal_content"><span v-html="body"></span></p>

    <template v-slot:modal-footer="{ ok }">
      <div class="sedna_error_modal_footer_div">
        <span class="sedna_error_modal_footer_content"><span v-html="footer"></span></span>
        <b-button v-if="!okHidden" variant="primary" @click="ok()">OK</b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>

export default {
  name: 'whats_new_modal',
  props: ['value', 'disable_dismiss'],
  computed: {
    okHidden: function() {
      return this.disable_dismiss;
    },
    footer: function() {
      return this.value.request_id ? 'RequestID: ' + this.value.request_id + '<br/>Sys message: ' + this.value.error_message: '';
    },
    body: function() {
      console.log(this.value);
      var msg = this.value.error_message;

      if(this.value.error_message === 'Unable To Send OTP Link')
      {
        msg = "<div style='margin-bottom: 12px;'>An error occurred while attempting your login.  Please try again.</div><div>This might occur if your email address was wrong, or if you clicked a login-email that has expired.  (These expire after about 15 minutes, for security reasons.)</div> "
      }
      return msg;
    }
  },
  mounted() {
    this.$root.$on('bv::modal::hide', (bvModalEvt) => {
      if (bvModalEvt.componentId === 'error_modal') {
        this.$emit('input', null)
      }
    })
  }
}

</script>
